import { render, staticRenderFns } from "./VoiceOfCustomerReport.vue?vue&type=template&id=d4cb7384&scoped=true&"
import script from "./VoiceOfCustomerReport.vue?vue&type=script&lang=js&"
export * from "./VoiceOfCustomerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cb7384",
  null
  
)

export default component.exports